import type { ComponentType } from "react";
import type { SlideProps } from "@/engine/app/offsite-config";
import { Slide01Titel } from "./slides/Slide01Titel";
import { Slide02Automatisierung } from "./slides/Slide02Automatisierung";
import { Slide03Kette } from "./slides/Slide03Kette";
import { Slide03bFrueherHeute } from "./slides/Slide03bFrueherHeute";
import { Slide04Nutzen } from "./slides/Slide04Nutzen";
import { Slide05WasIstKI } from "./slides/Slide05WasIstKI";
import { Slide06RpaMlLlm } from "./slides/Slide06RpaMlLlm";
import { Slide07LlmDenken } from "./slides/Slide07LlmDenken";
import { Slide07bHalluzination } from "./slides/Slide07bHalluzination";
import { Slide08Werkzeug } from "./slides/Slide08Werkzeug";
import { Slide09Klarstellung } from "./slides/Slide09Klarstellung";
import { Slide10DurchKI } from "./slides/Slide10DurchKI";
import { Slide11MitKI } from "./slides/Slide11MitKI";
import { Slide11bPromptenGutSchlecht } from "./slides/Slide11bPromptenGutSchlecht";
import { Slide11cSoArbeitetIhr } from "./slides/Slide11cSoArbeitetIhr";
import { Slide12Ueberleitung } from "./slides/Slide12Ueberleitung";
import { Slide13LiveLauf } from "./slides/Slide13LiveLauf";
import { Slide14LiveDemo } from "./slides/Slide14LiveDemo";
import { Slide15LiveSysteme } from "./slides/Slide15LiveSysteme";
import { Slide16Cliffhanger } from "./slides/Slide16Cliffhanger";
import { Slide17Reveal } from "./slides/Slide17Reveal";
import { Slide17bWasHeisstDas } from "./slides/Slide17bWasHeisstDas";
import { Slide18SorgenNoete } from "./slides/Slide18SorgenNoete";
import { Slide19Danke } from "./slides/Slide19Danke";

export const SLIDE_COMPONENTS: ComponentType<SlideProps>[] = [
  // Block 1 — Digitalisierung & Automatisierung (Folien 1–5)
  Slide01Titel,
  Slide02Automatisierung,
  Slide03Kette,
  Slide03bFrueherHeute,
  Slide04Nutzen,
  // Block 2 — Was ist KI (6–11)
  Slide05WasIstKI,
  Slide06RpaMlLlm,
  Slide07LlmDenken,
  Slide07bHalluzination,
  Slide08Werkzeug,
  Slide09Klarstellung,
  // Block 3 — Arbeiten durch KI vs. mit KI (12–13)
  Slide10DurchKI,
  Slide11MitKI,
  // Prompting-Intro (14–15)
  Slide11bPromptenGutSchlecht,
  Slide11cSoArbeitetIhr,
  // Workshop (16–17)
  Slide12Ueberleitung,
  Slide13LiveLauf,
  // Part 2 — SVO OS (Live-Demo) & Live-Systeme (18–19)
  Slide14LiveDemo,
  Slide15LiveSysteme,
  // Reveal & Abschluss (20–24)
  Slide16Cliffhanger,
  Slide17Reveal,
  Slide17bWasHeisstDas,
  Slide18SorgenNoete,
  Slide19Danke,
];
